import { Fragment } from 'react'
import { NextSeo } from 'next-seo'
import NextLink from 'next/link'
import { Box, Grid, Text, Button, Flex, Image } from '@chakra-ui/react'

function Error500(): React.ReactElement {
  return (
    <Fragment>
      <NextSeo title="500 - Internal Server Error" />
      <Flex
        width="100%"
        height="100vh"
        justifyContent="center"
        alignItems="center"
      >
        <Box maxW="850px" m="0 auto" p="4">
          <Grid
            gridTemplateColumns={{ base: '1fr', md: 'max-content 1fr' }}
            gap="4"
            alignItems="center"
          >
            <Box mr="8" textAlign="center">
              <Image
                maxW={{ base: '100%', sm: '430px' }}
                src="/images/503-error@2x.png"
              />
            </Box>
            <Grid gap="1">
              <Text as="h2" fontSize="36px" fontWeight="700">
                Sorry!
              </Text>
              <Text fontSize="26px">Internal Server Error</Text>
              <Text fontSize="16px" color="#888" fontWeight="300">
                Oops! Something went wrong… The server encountered an internal
                error ot misconfiguration and was unable to complete your
                request.
              </Text>
              <NextLink href="/" passHref>
                <Button
                  variant="outline"
                  colorScheme="gray"
                  size="lg"
                  mt="4"
                  borderRadius="md"
                >
                  Back Homepage
                </Button>
              </NextLink>
            </Grid>
          </Grid>
        </Box>
      </Flex>
    </Fragment>
  )
}

export default Error500
